// apps/web/src/content/hooks/queryConfig.ts
//
// Shared React Query options for the content hooks.
//
// Phase A content is seeded data that changes only when an operator
// reseeds the database. React Query's default `staleTime: 0` paired
// with `refetchOnWindowFocus: true` causes a refetch on every tab
// switch, which is wasteful for content that is effectively static
// across a session. A 5-minute `staleTime` lets window-focus
// refetches no-op for normal interaction patterns while still
// refreshing on long navigation-back gaps.
//
// Phase B (admin authoring) will need a more nuanced cache strategy:
// admin writes invalidate specific keys, and member reads should
// pick up the new content soon after. At that point the right answer
// is per-mutation invalidation, not a shorter staleTime — so this
// constant survives Phase B without churn.

export const CONTENT_STALE_TIME: number = 5 * 60 * 1000;
